var _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSkymonitorHorizontalNameLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "523.43713mm",
    height: "86.29705mm",
    viewBox: "0 0 523.43713 86.29705",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-24.770533,-103.4692)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.177019,
      fill: "#00000e",
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "M 43.351772,189.76625 H 151.14078 l 20.27955,-22.68806 8.95643,-29.51665 -17.01196,-25.29504 -24.72871,-8.79731 -25.5123,8.91886 -10.67455,21.14359 -20.653441,-11.24692 -19.502693,7.77662 -7.489921,21.26089 -20.810074,-0.99764 -9.222579,22.84292 z",
    id: "path233"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#00ccff",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 54.803185,151.32223 25.663432,4.08979 -18.173512,-25.35068 z",
    id: "path286"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#0088aa",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 80.466617,155.41202 1.329182,-33.1273 -19.502694,7.77662 z",
    id: "path288"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#00aad4",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 102.44924,133.53164 -21.982623,21.88038 1.329182,-33.1273 20.653441,11.24692",
    id: "path290"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#2ad4ff",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "M 43.351772,189.76625 80.466617,155.41202 54.803185,151.32223 Z",
    id: "path292"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#0088aa",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "M 43.351772,189.76625 H 97.246275 L 80.466617,155.41202 Z",
    id: "path294"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#0088aa",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 80.466617,155.41202 21.982623,-21.88038 23.92527,26.17465 -45.907893,-4.29427",
    id: "path296"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#006680",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 80.466617,155.41202 45.907893,4.29427 -29.128235,30.05996 z",
    id: "path298"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#00aad4",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 126.37451,159.70629 5.62346,30.05996 H 97.246275 l 29.128235,-30.05996",
    id: "path300"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#2ad4ff",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 151.14078,189.76625 -24.76627,-30.05996 5.62346,30.05996 h 19.14281",
    id: "path302"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#0088aa",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 151.14078,189.76625 2.56467,-25.79449 -27.33094,-4.26547 24.76627,30.05996",
    id: "path2529"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#55ddff",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 171.42033,167.07819 -17.71488,-3.10643 -2.56467,25.79449 20.27955,-22.68806",
    id: "path2531"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#00aad4",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 126.37451,159.70629 54.00225,-22.14475 -8.95643,29.51665 -45.04582,-7.3719",
    id: "path2609"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#55ddff",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 126.37451,159.70629 3.16958,-31.38913 34.12108,16.09731 z",
    id: "path2621"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#0088aa",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 163.66517,144.41447 -0.30037,-32.14797 17.01196,25.29504 -16.71159,6.85293",
    id: "path2623"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#00aad4",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 129.54409,128.31716 33.82071,-16.05066 0.30037,32.14797 z",
    id: "path2625"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#00ccff",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 138.63609,103.46919 -9.092,24.84797 33.82071,-16.05066 z",
    id: "path2627"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#0088aa",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 113.12379,112.38805 25.5123,-8.91886 -9.092,24.84797 -16.4203,-15.92911",
    id: "path2629"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#00ccff",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 102.44924,133.53164 10.67455,-21.14359 16.4203,15.92911 z",
    id: "path2631"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#00aad4",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 102.44924,133.53164 23.92527,26.17465 3.16958,-31.38913 -27.09485,5.21448",
    id: "path2633"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#00ccff",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "M 24.770532,173.16751 54.803185,151.32223 33.993111,150.32459 Z",
    id: "path2689"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#00aad4",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 24.770532,173.16751 18.58124,16.59874 11.451413,-38.44402 z",
    id: "path2691"
  }), /*#__PURE__*/React.createElement("g", {
    "aria-label": "SKY:Monitor",
    id: "text309",
    style: {
      fontSize: "70.5556px",
      fontFamily: "'Fira Code'",
      InkscapeFontSpecification: "'Fira Code'",
      fill: "#333333",
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 214.19747,163.21083 v -2.54001 q 0,-0.77611 0.77611,-0.77611 h 2.04612 q 0.77611,0 0.77611,0.77611 v 2.32834 q 0,7.05556 6.84389,7.05556 h 7.33778 q 6.8439,0 6.8439,-7.12612 v -2.96333 q 0,-3.10445 -2.54,-4.86834 -2.54001,-1.76389 -6.13834,-2.54 -3.59834,-0.77611 -7.26723,-1.62278 -3.59834,-0.84667 -6.13834,-3.10445 -2.54,-2.25778 -2.54,-6.06778 v -3.88056 q 0,-4.65667 2.68111,-7.33778 2.68112,-2.68111 7.26723,-2.68111 h 8.18445 q 4.58612,0 7.26723,2.68111 2.68111,2.68111 2.68111,7.33778 v 1.97556 q 0,0.77611 -0.77611,0.77611 h -2.04611 q -0.77611,0 -0.77611,-0.77611 v -1.76389 q 0,-7.05556 -6.8439,-7.05556 h -7.26722 q -6.77334,0 -6.77334,7.19667 v 3.52778 q 0,4.86834 8.67834,6.56167 3.59833,0.70556 7.19667,1.62278 3.66889,0.91722 6.20889,3.31612 2.54,2.39889 2.54,6.49111 v 3.45723 q 0,4.65667 -2.68111,7.33778 -2.68111,2.68111 -7.26723,2.68111 h -8.32556 q -4.58611,0 -7.26723,-2.68111 -2.68111,-2.68111 -2.68111,-7.33778 z",
    style: {
      fontFamily: "Rajdhani",
      InkscapeFontSpecification: "Rajdhani"
    },
    id: "path979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 256.88363,173.22972 h -2.04611 q -0.70556,0 -0.70556,-0.84667 v -43.67391 q 0,-0.84667 0.70556,-0.84667 h 2.04611 q 0.77611,0 0.77611,0.84667 v 26.03501 h 0.28222 q 0.42334,-1.12889 1.27,-2.32833 l 17.92113,-23.70668 q 0.635,-0.84667 1.48167,-0.84667 h 2.46944 q 0.91722,0 0.28222,0.84667 l -14.18167,18.97945 16.3689,24.69446 q 0.56444,0.84667 -0.42334,0.84667 h -1.97555 q -1.05834,0 -1.55223,-0.84667 l -14.67556,-22.01334 -7.26723,8.74889 v 13.26445 q 0,0.84667 -0.77611,0.84667 z",
    style: {
      fontFamily: "Rajdhani",
      InkscapeFontSpecification: "Rajdhani"
    },
    id: "path981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 303.94426,173.22972 h -2.04611 q -0.77611,0 -0.77611,-0.84667 v -16.29834 l -13.68779,-27.37557 q -0.42333,-0.84667 0.49389,-0.84667 h 2.54 q 0.635,0 0.98778,0.84667 l 11.2889,23.07168 h 0.35278 l 11.21834,-23.07168 q 0.35278,-0.84667 0.98778,-0.84667 h 2.61055 q 0.77611,0 0.49389,0.84667 l -13.75834,27.37557 v 16.29834 q 0,0.84667 -0.70556,0.84667 z",
    style: {
      fontFamily: "Rajdhani",
      InkscapeFontSpecification: "Rajdhani"
    },
    id: "path983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 328.99151,138.02248 v 8.46667 q 0,0.77611 -0.70556,0.77611 h -2.46944 q -0.77611,0 -0.77611,-0.77611 v -8.46667 q 0,-0.77612 0.77611,-0.77612 h 2.46944 q 0.70556,0 0.70556,0.77612 z m 0,25.96446 v 8.39611 q 0,0.84667 -0.70556,0.84667 h -2.46944 q -0.77611,0 -0.77611,-0.84667 v -8.39611 q 0,-0.77611 0.77611,-0.77611 h 2.46944 q 0.70556,0 0.70556,0.77611 z",
    style: {
      fontFamily: "Rajdhani",
      InkscapeFontSpecification: "Rajdhani"
    },
    id: "path985"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 372.3832,127.86247 h 3.81 q 0.70556,0 0.70556,0.84667 v 43.67391 q 0,0.84667 -0.70556,0.84667 h -2.04611 q -0.77611,0 -0.77611,-0.84667 v -39.0878 h -0.28223 l -12.48834,29.28058 q -0.42333,0.77611 -1.05833,0.77611 h -2.32834 q -0.70555,0 -0.98777,-0.77611 l -12.70001,-29.35114 h -0.28223 v 39.15836 q 0,0.84667 -0.70555,0.84667 h -2.04611 q -0.70556,0 -0.70556,-0.84667 v -43.67391 q 0,-0.84667 0.70556,-0.84667 h 3.81 q 0.49389,0 0.635,0.42333 l 13.26445,30.97391 h 0.28222 L 371.7482,128.2858 q 0.14111,-0.42333 0.635,-0.42333 z",
    style: {
      fontFamily: "Rajdhani",
      InkscapeFontSpecification: "Rajdhani"
    },
    id: "path987"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 403.4276,173.22972 h -6.06778 q -4.58612,0 -7.26723,-2.68111 -2.61056,-2.68111 -2.61056,-7.33778 v -15.94557 q 0,-4.65667 2.61056,-7.33778 2.68111,-2.68112 7.26723,-2.68112 h 6.06778 q 4.58611,0 7.26723,2.68112 2.68111,2.68111 2.68111,7.33778 v 15.94557 q 0,4.65667 -2.68111,7.33778 -2.68112,2.68111 -7.26723,2.68111 z m -5.78556,-3.175 h 5.50334 q 3.24556,0 4.93889,-1.76389 1.76389,-1.83445 1.76389,-5.15056 v -15.80446 q 0,-3.31611 -1.76389,-5.08 -1.69333,-1.83444 -4.93889,-1.83444 h -5.50334 q -3.24556,0 -4.93889,1.83444 -1.69334,1.76389 -1.69334,5.08 v 15.80446 q 0,3.31611 1.69334,5.15056 1.69333,1.76389 4.93889,1.76389 z",
    style: {
      fontFamily: "Rajdhani",
      InkscapeFontSpecification: "Rajdhani"
    },
    id: "path989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 425.93486,173.22972 h -2.04611 q -0.70555,0 -0.70555,-0.84667 v -34.29002 q 0,-0.84667 0.70555,-0.84667 h 2.04611 q 0.77612,0 0.77612,0.84667 v 2.82222 h 0.28222 q 1.97555,-3.66889 7.33778,-3.66889 h 4.65667 q 4.51556,0 7.12612,2.68112 2.61055,2.68111 2.61055,7.33778 v 25.11779 q 0,0.84667 -0.70555,0.84667 h -2.04611 q -0.77612,0 -0.77612,-0.84667 v -24.97668 q 0,-3.31611 -1.69333,-5.15056 -1.69334,-1.83444 -4.93889,-1.83444 h -4.58612 q -3.38667,0 -5.36222,1.83444 -1.905,1.76389 -1.905,5.08 v 25.04724 q 0,0.84667 -0.77612,0.84667 z",
    style: {
      fontFamily: "Rajdhani",
      InkscapeFontSpecification: "Rajdhani"
    },
    id: "path991"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 459.30766,131.31969 v -6.77334 q 0,-0.77611 0.70555,-0.77611 h 2.11667 q 0.70556,0 0.70556,0.77611 v 6.77334 q 0,0.84667 -0.70556,0.84667 h -2.11667 q -0.70555,0 -0.70555,-0.84667 z m 0,41.06336 v -34.29002 q 0,-0.84667 0.70555,-0.84667 h 2.04611 q 0.77612,0 0.77612,0.84667 v 34.29002 q 0,0.84667 -0.70556,0.84667 h -2.11667 q -0.70555,0 -0.70555,-0.84667 z",
    style: {
      fontFamily: "Rajdhani",
      InkscapeFontSpecification: "Rajdhani"
    },
    id: "path993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 475.32371,140.42137 h -4.3039 q -0.77611,0 -0.77611,-0.70556 v -1.69333 q 0,-0.77612 0.77611,-0.77612 h 4.3039 q 0.635,0 0.635,-0.635 v -5.715 q 0,-0.84667 0.77611,-0.84667 h 2.04611 q 0.77611,0 0.77611,0.84667 v 5.715 q 0,0.635 0.635,0.635 h 8.39612 q 0.77611,0 0.77611,0.77612 v 1.69333 q 0,0.70556 -0.77611,0.70556 h -8.39612 q -0.635,0 -0.635,0.635 v 22.22501 q 0,3.24556 1.83445,5.00945 1.83444,1.76389 5.15056,1.76389 h 2.75167 q 0.77611,0 0.77611,0.77611 v 1.62278 q 0,0.77611 -0.77611,0.77611 h -3.0339 q -4.65667,0 -7.47889,-2.61056 -2.82222,-2.61055 -2.82222,-7.19667 v -22.36612 q 0,-0.635 -0.635,-0.635 z",
    style: {
      fontFamily: "Rajdhani",
      InkscapeFontSpecification: "Rajdhani"
    },
    id: "path995"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 513.49431,173.22972 h -6.06778 q -4.58611,0 -7.26723,-2.68111 -2.61055,-2.68111 -2.61055,-7.33778 v -15.94557 q 0,-4.65667 2.61055,-7.33778 2.68112,-2.68112 7.26723,-2.68112 h 6.06778 q 4.58612,0 7.26723,2.68112 2.68111,2.68111 2.68111,7.33778 v 15.94557 q 0,4.65667 -2.68111,7.33778 -2.68111,2.68111 -7.26723,2.68111 z m -5.78556,-3.175 h 5.50334 q 3.24556,0 4.93889,-1.76389 1.76389,-1.83445 1.76389,-5.15056 v -15.80446 q 0,-3.31611 -1.76389,-5.08 -1.69333,-1.83444 -4.93889,-1.83444 h -5.50334 q -3.24556,0 -4.93889,1.83444 -1.69333,1.76389 -1.69333,5.08 v 15.80446 q 0,3.31611 1.69333,5.15056 1.69333,1.76389 4.93889,1.76389 z",
    style: {
      fontFamily: "Rajdhani",
      InkscapeFontSpecification: "Rajdhani"
    },
    id: "path997"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 536.00158,173.22972 h -2.04612 q -0.70555,0 -0.70555,-0.84667 v -34.29002 q 0,-0.84667 0.70555,-0.84667 h 2.04612 q 0.77611,0 0.77611,0.84667 v 2.96334 h 0.28222 q 0.77611,-1.48167 2.75167,-2.61056 1.97555,-1.19945 4.86833,-1.19945 h 2.75167 q 0.77611,0 0.77611,0.77612 v 1.69333 q 0,0.77611 -0.77611,0.70556 h -3.31611 q -3.45722,0 -5.43278,2.11666 -1.905,2.11667 -1.905,5.71501 v 24.13001 q 0,0.84667 -0.77611,0.84667 z",
    style: {
      fontFamily: "Rajdhani",
      InkscapeFontSpecification: "Rajdhani"
    },
    id: "path999"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkymonitorHorizontalNameLogo);
export default __webpack_public_path__ + "static/media/skymonitor-horizontal-name-logo.f9e5a798092c4ec9414e36d65288ac3e.svg";
export { ForwardRef as ReactComponent };